@if (properties) {
  @for (propertyName of propertyNames; track propertyName) {
    <div>
      @if (isMsisdnField(propertyName)) {
        <app-msisdn-input
            [readonly]="isPropertyReadonly(propertyName)"
            [passedFormControl]="$any(form.controls[propertyName])"
            [formErrors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
            [required]="false"
            [controlName]="propertyName"
            [icon]="false"
            [showErrors]="false"/>
      } @else if (properties.isDateField(propertyName)) {
        @if (properties.getField(propertyName)['subType'] === 'composite') {
          <app-property-composite-date
              [class]="'field-' + propertyName"
              [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
              [formControl]="$any(form.controls[propertyName])"
              [controlName]="propertyName"
              [schemaTranslations]="schemaTranslations$ | async"
              [properties]="properties"
              [submitted]="isFormSubmitted"/>
        } @else {
          <app-property-date [class]="'field-' + propertyName"
                             [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                             [formControl]="$any(form.controls[propertyName])"
                             [controlName]="propertyName"
                             [schemaTranslations]="schemaTranslations$ | async"
                             [properties]="properties"/>
        }
      } @else if (properties.isSingleSelectable(propertyName)) {
        <app-property-single-enum [class]="'field-' + propertyName"
                                  [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                                  [formControl]="$any(form.controls[propertyName])"
                                  [controlName]="propertyName"
                                  [schemaTranslations]="schemaTranslations$ | async"
                                  [properties]="properties"/>
      } @else if (properties.isGroupedHash(propertyName)) {
        <app-property-grouped-hash [class]="'field-' + propertyName"
                                   [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                                   [formControl]="$any(form.controls[propertyName])"
                                   [controlName]="propertyName"
                                   [schemaTranslations]="schemaTranslations$ | async"
                                   [properties]="properties"/>
      } @else if (properties.isMultiSelectable(propertyName)) {
        @if (properties.isMultiCustom(propertyName)) {
          <app-property-array-custom [class]="'field-' + propertyName"
                                     [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                                     [formControl]="$any(form.controls[propertyName])"
                                     [controlName]="propertyName"
                                     [schemaTranslations]="schemaTranslations$ | async"
                                     [properties]="properties"/>
        } @else {
          @switch (properties.getField(propertyName)['subType']) {
            @default {
              <app-property-array-fixed [class]="'field-' + propertyName"
                                        [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                                        [formControl]="$any(form.controls[propertyName])"
                                        [controlName]="propertyName"
                                        [schemaTranslations]="schemaTranslations$ | async"
                                        [properties]="properties"/>
            }
            @case ('dynamic') {
              <app-property-array-dynamic [class]="'field-' + propertyName"
                                          [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                                          [formControl]="$any(form.controls[propertyName])"
                                          [controlName]="propertyName"
                                          [schemaTranslations]="schemaTranslations$ | async"
                                          [properties]="properties"/>
            }
          }
        }
      } @else {
        <app-property-normal-input [class]="'field-' + propertyName"
                                   [errors]="form.errors ? form.errors[propertyName] : apiErrors ? apiErrors[propertyName] : undefined"
                                   [readonly]="isPropertyReadonly(propertyName)"
                                   [formControl]="$any(form.controls[propertyName])"
                                   [controlName]="propertyName"
                                   [schemaTranslations]="schemaTranslations$ | async"
                                   [properties]="properties"/>
      }
      @if ((isUserPasswordAvailable$ | async) && isEmailField(propertyName)) {
        @if (isNewProfile) {
          <app-password-input-confirmation
              class="field-password"
              [errors]="form.errors ? form.errors['password'] : apiErrors ? apiErrors['password'] : undefined"
              [submitted]="isFormSubmitted"
              [formControl]="$any(form.get('password'))"
              [properties]="properties"/>
        } @else {
          <div>
            <a class="btn btn-raised btn-default btn-sm"
               [routerLink]="['../..', 'profile', 'change_password']">
              {{ 'profile-form.profile-form.change_password' | translate }}
            </a>
          </div>
        }
      }
      @if (!apiErrors[propertyName]) {
        @if (mapControlError(propertyName, form.controls[propertyName].errors); as controlErrors) {
          <app-input-errors [errorsForField]="controlErrors"
                            [translationKey]="'errors.members'"/>
        } @else {
          <app-input-errors [errorsForField]="form.errors ? form.errors[propertyName] : undefined"
                            [translationKey]="'errors.members'"/>
        }
      }
      <app-input-errors [errorsForField]="apiErrors ? apiErrors[propertyName] : undefined"
                        [translationKey]="'errors.members'"/>
    </div>
  }
}
